// ----------------------------------------------------------------------
// <copyright file="Izenda.SelectionField.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var TreeSelectionField = require('../FieldContainers/Izenda.TreeSelectionField');
  var { get, map } = require('lodash/fp');

  var SelectionField = React.createClass({
    propTypes: {
      value: React.PropTypes.object
    },

    componentWillMount: function() {
      this.selectedData = [];
      this.selectedFields = [];
    },

    // Return data for update data.
    getValue: function() {
      return {
        selectedFields: this.selectedFields
      };
    },

    onChangeSeletedField: function(data) {
      var filterQuerySource = get('value.fieldQuerySource', this.props);
      this.selectedFields = map(function(item) {
        var querySource = filterQuerySource[item.querySource];
        var field = querySource.fields[item.field];

        return {
          field: field,
          querySource: querySource
        };
      }, data);

      this.selectedData = data;
    },

    render: function() {
      var filterQuerySource = get('value.fieldQuerySource', this.props);
      return <TreeSelectionField data={filterQuerySource} onChangeData={this.onChangeSeletedField} />;
    }
  });

  module.exports = observer(SelectionField);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.SelectionField.jsx